
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy_setting",
      function () {
        return require("private-next-pages/privacy_setting.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy_setting"])
      });
    }
  